/**
 * THC and weight figures rendered side by side must line up, so they always
 * carry one decimal: "20.0% THC", "100.0 lbs". A column of "9.5%", "20%",
 * "100%" ragged-edges and reads as unsorted data.
 */
import { GRAMS_PER_LB } from '@/lib/buyRequestParser';
import { formatFixed } from '@/lib/utils';

/** "20.0%" — one decimal, always. Null stays null so callers can drop the row. */
export function formatThc(percent: number | null | undefined): string | null {
  return percent == null ? null : `${formatFixed(percent, 1)}%`;
}

/** "100.0 lbs" from grams — one decimal, always. */
export function formatLbs(grams: number | null | undefined, unit = ' lbs'): string | null {
  return grams == null ? null : `${formatFixed(grams / GRAMS_PER_LB, 1)}${unit}`;
}
